export enum TestTypesEnum {
  SELF_TEST = "self-test",
  INSTITUTE_TEST = "institute-test",
  SELF_TEST_SERIES = "self-test-series",
  PRELOADED_TEST = "preloaded-test",
  PAST_YEAR_TEST = "past-year-test",
}

export enum QuestionStatusEnum {
  UNSEEN = "unseen",
  UNANSWERED = "unanswered",
  ANSWERED = "answered",
  MARKED_FOR_REVIEW = "markedForReview",
  CURRENT_QUESTION = "currentQuestion",
  CORRECT = "correct",
  INCORRECT = "incorrect",
  SKIPPED = "skipped",
}

export enum QuestionReportStatusEnum {
  CORRECT = "correct",
  INCORRECT = "incorrect",
  SKIPPED = "skipped",
  EVALUATION_PENDING = "evaluationPending",
}

export enum EventTypesEnum {
  START_TEST = "start_test",
  RESUME_TEST = "resume_test",
  VIEW_QUESTION = "view_question",
  SELECT_ANSWER = "select_answer",
  INPUT_ANSWER = "input_answer",
  UPLOAD_ANSWER = "upload_answer",
  CLEAR_ANSWER = "clear_answer",
  SUBMIT_ANSWER = "submit_attempt",
  MARK_FOR_REVIEW = "mark_for_review",
  VIEW_TEST_PAPER = "view_test_paper",
  VIEW_TEST_PAPER_CLOSE = "view_test_paper_close",
  INSTRUCTIONS_CONFIRMED = "instructions_confirmed",
  VIEW_INSTRUCTIONS = "view_instructions",
  VIEW_INSTRUCTIONS_CLOSE = "view_instructions_close",
  FULLSCREEN_DISABLED = "fullscreen_disabled",
  END_TEST_POPUP_OPEN = "end_test_popup_open",
  END_TEST_POPUP_CLOSE = "end_test_popup_close",
  USER_END_TEST = "user_end_test",
  END_TEST_SUCCESSFUL = "end_test_successful",
  AUTO_END_TEST_TIMER = "auto_end_test_timer",
  AUTO_END_TEST_FULLSCREEN = "auto_end_test_fullscreen",
}

export enum StudentOmrStatusEnum {
  PENDING = "Pending",
  UPLOADED = "Uploaded",
  APPROVED = "Approved",
  REVIEW = "Review",
  DUPLICATE = "Duplicate",
  ABSENT = "Absent",
}

export enum OmrStatusEnum {
  NEW = 1,
  APPROVED = 2,
  REVIEW = 3,
  REJECTED = 4,
  FAILED = 5,
}

export enum PastYearPaperPeriodsEnum {
  LAST_3_YEARS = 3,
  LAST_5_YEARS = 5,
  LAST_10_YEARS = 10,
}
